import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { User } from './user';
import * as _ from 'underscore';
import { UserData } from '../shared/service/UserService';

@Injectable()
export class CardService {
    private apiUrl: string;
    private header;
    private headerAppJSON;

    constructor(private http: HttpClient) {
        this.apiUrl = UserData.backend_url + '/v1';
        this.header = this.getHeader();
        this.headerAppJSON = this.getHeaderAppJSON();
    }

    public getHeader() {
      
        let authorizationString = "Bearer " + UserData.token;
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': authorizationString
            })
        };
        return httpOptions;
    }

    public getHeaderAppJSON() {
        let authorizationString = "Bearer " + UserData.token;
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': authorizationString,
                'Content-Type': 'application/json'
            })
        };
        return httpOptions;
    }

    private handleError(error: Response) {
        console.error(error);
        return throwError(error || error);
    }

    public getUserDetails() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/userDetails/';
        return this.http.get(url, this.headerAppJSON);
    }

    public sendNoAccessNotification(data) {
        const url = this.apiUrl + '/sendNoAccessNotification/';
        const body: any = data;
        return this.http.post(url, body, this.header);
    }

    public getSubApps(userName, appCode) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/getSubAppListByUserName?userName=' + userName + '&&appId=' + appCode;
        return this.http.get(url, this.headerAppJSON);
    }

    public getUrl() {
        const url = this.apiUrl + '/getMatomoDetails';
        return this.http.get(url, this.headerAppJSON);
    }

    public user() {
        const url = this.apiUrl + '/token/';

        let body: User;
        return this.http.post(url, body, this.header).pipe(catchError(this.handleError));
    }

    public userResolver() {
        const url = this.apiUrl + '/token/';
        let body: User;
        return this.http.post(url, body, this.header).pipe(catchError(this.handleError));
    }

    public saveOrganization(data, flag) {
        let url = "";
        if (flag)
            url = this.apiUrl + '/organizations/' + data.id + '/updateOrganization';
        else
            url = this.apiUrl + '/organizations';
        return this.http.post(url, data, this.header).pipe(catchError(this.handleError));
    }

    public getOrganization() {
        const url = this.apiUrl + '/organizations';
        return this.http.get(url, this.header);
    }

    public getSingleOrgApp() {
        const url = this.apiUrl + '/organizations/' + UserData.organizationId;
        return this.http.get(url, this.header);
    }

    public leaveOrgnization(data) {
        const url = this.apiUrl + '/organizations/' + data.id + "/leaveOrganization";
        const authorizationString = 'Bearer ' + UserData.token;
        return this.http.post(url, this.header);
    }

    public saveImage(file) {
        var fd = new FormData();
        fd.append('file', file);
        const url = this.apiUrl + '/saveLogo';
        return this.http.post(url, fd, this.header);
    }

    public imageLogo(id) {
        const url = this.apiUrl + '/organizations/' + id;
        return this.http.get(url, this.header);
    }

    public getPracticeset() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + "/practicesetsUIAllGames";
        return this.http.get(url, this.header);
    }

    public getTeams() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + "/teams";
        return this.http.get(url, this.header);
    }

    public getMembers() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + "/getUsersDashboard";
        return this.http.get(url, this.header);
    }

    public getFeedbacks() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/feedbacksDashBoard/';
        return this.http.get(url, this.header);
    }

    public updateRequiredFolder(flag) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/folder/' + flag;
        return this.http.post(url, this.header);
    }
}
